module.exports = __webpack_public_path__ + "media/images/icons/clock_landing-2c8deab693ae38ab72cf0126f97186e6.svg";